export const useHelpers = () => {
  const generateSeoLocaleParams = (localeParams, param) => {
    const params = isRef(localeParams) ? localeParams : ref(localeParams)
    const { locales } = useI18n()

    const languageToLocaleMap = locales.value.reduce((acc, locale) => {
      acc[locale.language] = locale.code
      return acc
    }, {})

    return params.value.reduce((acc, item) => {
      const locale = languageToLocaleMap[item.language] || item.language
      return { ...acc, [locale]: { [param]: item.slug } }
    }, {})
  }

  return {
    generateSeoLocaleParams,
  }
}
